import ActivityPageCard from './ActivityPageCard'
export default ActivityPageCard

